import moment from "moment-jalaali";

class Today {
    Now() {
        return new Date(Date.now())
    }
    Date() {
        return Number(this.Now().getDate(this.Now()))
    }
    Month() {
        return Number(this.Now().getMonth(this.Now()))
    }
    Year() {
        return Number(this.Now().getFullYear(this.Now()))
    }
    Obj() {
        return ({
            Day: this.Date(),
            Month: this.Month(),
            Year: this.Year(),
            Hour: moment(this.Now()).format('HH'),
            Min: moment(this.Now()).format('mm')
        })
    }

}
export default new Today